export const featuredRaffles = [
  {
    id: 1,
    image: '/assets/images/raffle/raffle-image-1.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
  {
    id: 2,
    image: '/assets/images/raffle/raffle-image-2.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
  {
    id: 3,
    image: '/assets/images/raffle/raffle-image-3.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
  {
    id: 4,
    image: '/assets/images/raffle/raffle-image-4.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
  {
    id: 5,
    image: '/assets/images/raffle/raffle-image-5.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
  {
    id: 6,
    image: '/assets/images/raffle/raffle-image-6.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
  {
    id: 7,
    image: '/assets/images/raffle/raffle-image-7.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
  {
    id: 8,
    image: '/assets/images/raffle/raffle-image-8.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
];

export const collectionDetailRaffles = [
  {
    image: '/assets/images/raffle/raffle-image-5.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
  {
    image: '/assets/images/raffle/raffle-image-6.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },

  {
    image: '/assets/images/raffle/raffle-image-7.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },

  {
    image: '/assets/images/raffle/raffle-image-8.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
  {
    image: '/assets/images/raffle/raffle-image-9.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
  {
    image: '/assets/images/raffle/raffle-image-10.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
  {
    image: '/assets/images/raffle/raffle-image-11.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
  {
    image: '/assets/images/raffle/raffle-image-12.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
  {
    image: '/assets/images/raffle/raffle-image-13.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
  {
    image: '/assets/images/raffle/raffle-image-14.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
  },
];


export const createdRaffles = [
  {
    image: '/assets/images/raffle/raffle-image-5.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
    endDate: 'dd/mm/yyyy',
    status: 'Pending',
  },
  {
    image: '/assets/images/raffle/raffle-image-6.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
    endDate: 'dd/mm/yyyy',
    status: 'Pending',
  },

  {
    image: '/assets/images/raffle/raffle-image-7.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
    endDate: 'dd/mm/yyyy',
    status: 'Pending',
  },

  {
    image: '/assets/images/raffle/raffle-image-8.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
    endDate: 'dd/mm/yyyy',
    status: 'Pending',
  },
  {
    image: '/assets/images/raffle/raffle-image-9.png',

    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
    endDate: 'dd/mm/yyyy',
    status: 'Pending',
  },
  {
    image: '/assets/images/raffle/raffle-image-10.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
    endDate: 'dd/mm/yyyy',
    status: 'Pending',
  },
];

export const joinedRaffles = [
  {
    image: '/assets/images/raffle/raffle-image-5.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
    status: 'pending',
  },
  {
    image: '/assets/images/raffle/raffle-image-6.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
    status: 'pending',
  },
  {
    image: '/assets/images/raffle/raffle-image-7.png',

    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
    status: 'pending',
  },
  {
    image: '/assets/images/raffle/raffle-image-8.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
    status: 'pending',
  },
  {
    image: '/assets/images/raffle/raffle-image-9.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
    status: 'ended',
  },
  {
    image: '/assets/images/raffle/raffle-image-10.png',
    title: 'Fukuhedrons #123',
    creator: 'Raffle Creator',
    ticketsSold: '00/10,000',
    ticketsPrice: 0.01,
    status: 'ended',
  },
];
